import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {MatStepper} from '@angular/material/stepper';
import {ToastrService} from 'ngx-toastr';
import {finalize} from 'rxjs';
import html2canvas from 'html2canvas';
import {QuizVitalidadeResultadoVM} from 'src/app/api/model/quiz-vitalidade/quiz-vitalidade-resultadoVM';
import {QuizStepEnum} from 'src/app/api/module/erp/shared/enumerable/quiz-estilo-de-vida-step.enum';
import {ErrorLoggingService} from 'src/app/api/module/erp/shared/services/error-logs/error-logging.service';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
import {DadosTesteVitalidadeService} from 'src/app/api/module/externo/services/quiz-teste-vitalidade/dados-quiz-teste-vitalidade.service';
import {QuizTesteVitalidadeService} from 'src/app/api/module/externo/services/quiz-teste-vitalidade/quiz-teste-vitalidade.service';
import {VerificaEmail} from 'src/app/components/helper/form-validators/verifica-email';
import {ScrollService} from 'src/app/components/helper/service/scroll/scroll.service';

@Component({
  selector: 'app-quiz-teste-vitalidade',
  templateUrl: './quiz-teste-vitalidade.component.html',
  styleUrls: ['./quiz-teste-vitalidade.component.scss'],
})
export class QuizTesteVitalidadeComponent implements OnInit {
  @ViewChild('resultadoCompartilhavel') resultadoCompartilhavel!: ElementRef<HTMLElement>;
  @ViewChild('stepper', {read: ElementRef}) stepperElement!: ElementRef<HTMLElement>;

  @ViewChild('stepper') set matStepper(stepper: MatStepper) {
    this.stepper = stepper;
    this.atualizarStepper();
  }

  stepper!: MatStepper;
  isLinear: boolean = false;
  stepAtual: QuizStepEnum = QuizStepEnum.CADASTRO;
  quizEnum = QuizStepEnum;
  formQuiz!: FormGroup;
  formTouched: boolean = false;
  errorMessage: boolean = false;
  isFormSubmited: boolean = false;
  listaDePerguntas = new Array<any>();
  respostasPerguntaAtual = new Array<any>();
  perguntaAtual: any = {};
  idTesteVitalidade: string = '';
  ordemPerguntas: number = 0;
  sexoSelecionado: number | null = null;
  resultado: QuizVitalidadeResultadoVM | null = null;

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private _scrollService: ScrollService,
    private _quizTesteVitalidadeService: QuizTesteVitalidadeService,
    private _dadosTesteVitalidadeService: DadosTesteVitalidadeService,
    private _spinnerService: SpinnerService,
    private errorLogging: ErrorLoggingService,
  ) {}

  ngOnInit(): void {
    this.criarFormularioQuiz();
  }

  criarFormularioQuiz() {
    this.formQuiz = this.formBuilder.group({
      name: new FormControl(null, [Validators.required]),
      age: new FormControl(null, [Validators.required]),
      sex: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [
        Validators.required,
        Validators.email,
        Validators.minLength(2),
        Validators.maxLength(250),
        Validators.required,
        VerificaEmail,
      ]),
      response: new FormControl(null),
    });
  }

  onFieldChange() {
    if (this.formTouched) {
      this.errorMessage = !this.isFormValid();
    }
  }

  isFormValid() {
    this.isFormSubmited = true;
    return this.formQuiz.valid;
  }

  gotoTop() {
    this._scrollService.scrollToElement('top-form', 140);
    this._scrollService.setStyle('#top-form', {
      'margin-top': '-141px !important',
    });
    this.stepperElement?.nativeElement
      .querySelector<HTMLElement>('.mat-horizontal-content-container')
      ?.scrollTo({top: 0, behavior: 'smooth'});
  }

  getStepIndexFromEnum(enumValue: number): number {
    const stepsOrder = [QuizStepEnum.CADASTRO, QuizStepEnum.PERGUNTAS, QuizStepEnum.RESULTADO];
    return stepsOrder.indexOf(enumValue);
  }

  //Controle de Step
  redirecionamentoDeStep() {
    this.gotoTop();
    if (this.stepper) {
      this.stepper.selectedIndex = this.getStepIndexFromEnum(this.stepAtual);
    }
  }

  atualizarStepper() {
    setTimeout(() => {
      if (this.stepper) {
        this.stepper.selectedIndex = this.getStepIndexFromEnum(this.stepAtual);
      }
    });
  }

  get progressoPercentual(): number {
    const indicePerguntaAtual = this.listaDePerguntas.findIndex(
      pergunta => pergunta.order === this.perguntaAtual.order,
    );

    if (indicePerguntaAtual < 0 || this.listaDePerguntas.length === 0) {
      return 0;
    }

    return Number((((indicePerguntaAtual + 1) / this.listaDePerguntas.length) * 100).toFixed(1));
  }

  onCadastrar() {
    this.formTouched = true;

    if (!this.isFormValid()) {
      this.toastr.warning('Por favor, preencha os campos obrigatórios antes de começar o quiz.');
      this.toastr.toastrConfig.preventDuplicates = true;

      this.errorMessage = true;
      this.isFormSubmited = true;
      return;
    }

    let dadosUsuario = {
      name: this.formQuiz.controls['name'].value,
      age: this.formQuiz.controls['age'].value,
      sex: this.formQuiz.controls['sex'].value,
      email: this.formQuiz.controls['email'].value,
    };
    this.sexoSelecionado = dadosUsuario.sex === 1 || dadosUsuario.sex === 2 ? dadosUsuario.sex : null;

    this.iniciarSpinner();
    this._quizTesteVitalidadeService
      .iniciarQuiz(dadosUsuario)
      .pipe(finalize(() => this.pararSpinner()))
      .subscribe({
        next: data => {
          const step = Number(data?.step);
          this.toastr.toastrConfig.preventDuplicates = true;

          if (step !== QuizStepEnum.PERGUNTAS && step !== QuizStepEnum.RESULTADO) {
            this.toastr.error('Não foi possível identificar a etapa atual do teste.');
            return;
          }

          this.idTesteVitalidade = data.id;
          this.sexoSelecionado = data.sex === 1 || data.sex === 2 ? data.sex : this.sexoSelecionado;

          if (step === QuizStepEnum.RESULTADO) {
            if (!data.result) {
              this.toastr.error('Não foi possível carregar o resultado do teste.');
              return;
            }

            this.resultado = data.result;
          } else {
            if (!Array.isArray(data.questions) || data.questions.length === 0) {
              this.toastr.error('Não foi possível carregar as perguntas do teste.');
              return;
            }

            if (!this.buscarPerguntas(data.questions)) {
              return;
            }
          }

          this.stepAtual = step as QuizStepEnum;
          this.redirecionamentoDeStep();
          this.formQuiz.reset();
        },
        error: error => {
          this.errorLogging.logError('Erro ao iniciar o teste de vitalidade.', error, {
            contexto: 'Erro onCadastrar do componente quiz-teste-vitalidade',
            dados: dadosUsuario,
          });
          this.toastr.error(error.message || 'Não foi possível acessar o teste de vitalidade.');
          this.toastr.toastrConfig.preventDuplicates = true;
        },
      });
  }

  buscarPerguntas(dados: any[]): boolean {
    this.listaDePerguntas = [...dados].sort((perguntaA, perguntaB) => perguntaA.order - perguntaB.order);
    const primeiraPerguntaPendente = this.listaDePerguntas.find(pergunta => pergunta.selectedOptionId == null);

    if (!primeiraPerguntaPendente) {
      this.toastr.error('Não há perguntas pendentes para responder.');
      this.toastr.toastrConfig.preventDuplicates = true;
      return false;
    }

    this.exibirPergunta(primeiraPerguntaPendente);
    return true;
  }

  private exibirPergunta(pergunta: any) {
    this.perguntaAtual = {
      description: pergunta.description,
      id: pergunta.id,
      order: pergunta.order,
    };
    this.ordemPerguntas = pergunta.order;
    this.respostasPerguntaAtual = pergunta.options;
    this.adicionarImgPerguntas();
  }

  onChangeRespostaQuiz(pergunta: any, resposta: any) {
    let dadosParaEnviar = null;
    let perguntaAtual = pergunta;
    let idrespostaAtual = resposta.id;

    if (this.idTesteVitalidade !== null && perguntaAtual !== undefined && idrespostaAtual) {
      dadosParaEnviar = {
        vitalityQuizPersonalDataId: this.idTesteVitalidade,
        vitalityQuizQuestionId: perguntaAtual.id,
        vitalityQuizOptionId: idrespostaAtual,
      };
      this.iniciarSpinner();
      this._quizTesteVitalidadeService
        .responderQuiz(dadosParaEnviar)
        .pipe(finalize(() => this.pararSpinner()))
        .subscribe({
          next: data => {
            const perguntaRespondida = this.listaDePerguntas.find((item: any) => item.id === perguntaAtual.id);
            if (perguntaRespondida) {
              perguntaRespondida.selectedOptionId = idrespostaAtual;
            }
            this.verificarPergunta(perguntaAtual);
          },
          error: error => {
            this.errorLogging.logError('Erro ao responder o quiz teste vitalidade.', error, {
              contexto: 'Erro onCadastrar do componente quiz-teste-vitalidade',
              dados: dadosParaEnviar,
            });
            this.toastr.error(error.message || 'Não foi possível responder a pergunta do quiz de vitalidade.');
            this.toastr.toastrConfig.preventDuplicates = true;
          },
        });
    }
  }

  verificarPergunta(perguntaAtual: any) {
    const proximaPergunta = this.listaDePerguntas.find(
      (item: any) => item.order > perguntaAtual.order && item.selectedOptionId == null,
    );
    this.gotoTop();

    if (proximaPergunta) {
      this.exibirPergunta(proximaPergunta);
      this.gotoTop();
    } else {
      // Todas as perguntas respondidas
      this.finalizarQuiz();
    }
  }

  adicionarImgPerguntas() {
    this._dadosTesteVitalidadeService.imgPerguntas().subscribe({
      next: data => {
        let dadosRecebidos = data;

        const itemPergunta = dadosRecebidos.find((item: any) => item.pergunta === this.perguntaAtual.order);

        if (itemPergunta) {
          // Mapeia e atualiza as respostas da pergunta atual adicionando a imagem correspondente
          this.respostasPerguntaAtual = this.respostasPerguntaAtual.map((resposta: any) => {
            const opcoesImagem = [itemPergunta.opcaoUm, itemPergunta.opcaoDois, itemPergunta.opcaoTres];
            const imagensDaOpcao = opcoesImagem[resposta.order - 1] || [];
            const imagemEncontrada =
              imagensDaOpcao.find((imagem: any) => imagem.sexo === this.sexoSelecionado)?.img || '';

            return {
              ...resposta,
              img: imagemEncontrada,
            };
          });
        }
      },
    });
  }

  finalizarQuiz() {
    this.iniciarSpinner();
    this._quizTesteVitalidadeService
      .finalizarQuiz(this.idTesteVitalidade)
      .pipe(finalize(() => this.pararSpinner()))
      .subscribe({
        next: data => {
          if (!data?.participantId || typeof data.vitalityAge !== 'number') {
            this.toastr.error('Não foi possível carregar o resultado do teste.');
            this.toastr.toastrConfig.preventDuplicates = true;
            return;
          }

          this.resultado = data;
          this.stepAtual = QuizStepEnum.RESULTADO;
          this.redirecionamentoDeStep();
        },
        error: error => {
          this.errorLogging.logError('Erro ao finalizar o teste de vitalidade.', error, {
            contexto: 'Erro finalizarQuiz do componente quiz-teste-vitalidade',
            dados: this.idTesteVitalidade,
          });
          this.toastr.error(error.message || 'Não foi possível finalizar o teste de vitalidade.');
          this.toastr.toastrConfig.preventDuplicates = true;
        },
      });
  }

  get imagemResultado(): string {
    if (!this.resultado) {
      return '';
    }

    const sexo = this.resultado.sex === 1 ? 'homem' : 'mulher';
    const status = this.resultado.statusDescription.toLocaleLowerCase('pt-BR');
    let categoria = 'intermediario';

    if (status.includes('desenvolvimento')) {
      categoria = 'desenvolvimento';
    } else if (status.includes('positivo')) {
      categoria = 'positivo';
    } else if (this.resultado.status === 1) {
      categoria = 'positivo';
    } else if (this.resultado.status === 3) {
      categoria = 'desenvolvimento';
    }

    return `assets/app-assets/images/quiz-teste-vitalidade/resultado/${sexo}-${categoria}.png`;
  }

  async compartilharResultado(): Promise<void> {
    try {
      const canvas = await html2canvas(this.resultadoCompartilhavel.nativeElement, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff',
        onclone: clonedDocument => {
          clonedDocument.querySelector('.vitality-share-button')?.remove();
        },
      });
      const imageBlob = await new Promise<Blob>((resolve, reject) => {
        canvas.toBlob(blob => {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error('Não foi possível gerar a imagem do resultado.'));
          }
        }, 'image/png');
      });
      const imageFile = new File([imageBlob], 'resultado-teste-vitalidade.png', {type: 'image/png'});

      if (navigator.share && navigator.canShare?.({files: [imageFile]})) {
        await navigator.share({
          title: 'Meu resultado no Teste de Vitalidade | Geia',
          text: 'Confira meu resultado no Teste de Vitalidade!',
          files: [imageFile],
        });
        return;
      }

      this.baixarImagemResultado(canvas);
      this.toastr.success('Imagem salva. Agora você pode compartilhá-la nas redes sociais.');
      this.toastr.toastrConfig.preventDuplicates = true;
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') {
        return;
      }
      this.errorLogging.logError('Erro ao compartilhar o resultado do teste de vitalidade.', error, {
        contexto: 'Erro compartilharResultado do componente quiz-teste-vitalidade',
      });
      this.toastr.error('Não foi possível gerar ou compartilhar a imagem do resultado.');
      this.toastr.toastrConfig.preventDuplicates = true;
    }
  }

  private baixarImagemResultado(canvas: HTMLCanvasElement): void {
    const link = document.createElement('a');
    link.download = 'resultado-teste-vitalidade.png';
    link.href = canvas.toDataURL('image/png');
    link.click();
  }

  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }
}
